// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/.pnpm/css-loader@7.1.2_@rspack+core@1.5.3_webpack@5.99.9/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/.pnpm/css-loader@7.1.2_@rspack+core@1.5.3_webpack@5.99.9/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `a:where(:any-link:not(.button)),
.d-anchor {
  --bg: transparent;
  --bg-hover: var(--color-gray-02);
  --bg-active: var(--color-gray-01);
  --color: var(--link-color);
  --color-hover: var(--link-color);
  --color-visited: var(--visited-link-color);

  background-color: var(--bg);
  border: none;
  border-radius: var(--default-outline-radius);
  color: var(--color);
  cursor: pointer;
  flex-shrink: 0;

  /* Inherit these properties for button.d-anchor. (<a> does this by default.) */
  font-family: inherit;
  font-size: inherit;
  font-weight: inherit;
  line-height: inherit;
  min-height: 0;
  min-width: 0;
  outline: none;
  -webkit-text-decoration: underline 0.075em;
          text-decoration: underline 0.075em;
  text-underline-offset: 0.175em;
  transition:
    background-color var(--default-transition),
    outline var(--default-transition);
}

:is(a:where(:any-link:not(.button)),.d-anchor)::-moz-focus-inner {
    border: 0;
  }

:is(a:where(:any-link:not(.button)),.d-anchor):visited {
    color: var(--color-visited);
  }

:is(a:where(:any-link:not(.button)),.d-anchor):hover {
    background-color: var(--bg-hover);
    color: var(--color-hover);
  }

:is(a:where(:any-link:not(.button)),.d-anchor):active {
    background-color: var(--bg-active);
  }

:is(a:where(:any-link:not(.button)),.d-anchor):disabled {
    color: var(--disabled-color);
    pointer-events: none;
  }

button.d-anchor {
  padding: 0;
}

.is-keynav a:where(:any-link:not(.button)):focus,.is-keynav .d-anchor:focus {
    outline: var(--default-outline);
    outline-offset: var(--default-outline-offset);
  }

.dark-bg a:where(:any-link:not(.button)),.dark-bg .d-anchor {
    --color: var(--color-white-08);
    --color-hover: var(--color-white-08);
    --color-visited: var(--color-white-08);
    --bg-hover: var(--color-white-03);
    --bg-active: var(--color-white-01);
  }

/* Less prominent link variant: no text decoration, and appears blue on hover only. */

.d-anchor-light,
  /* This style was used already before this anchor variant was defined. In order not to have to duplicate the style
  while also not to have have to retrofit all places where it was already used, we provide this special context class.
  Most new usages should probably assign the "d-anchor-light" class on the links themselves, for more flexibility. */
.d-anchor-light-context :is(a:where(:any-link:not(.button)), .d-anchor) {
  --bg: transparent;
  --bg-hover: transparent;
  --bg-active: transparent;
  --color: unset;
  --color-visited: unset;
}

:is(.d-anchor-light,.d-anchor-light-context :is(a:where(:any-link:not(.button)),.d-anchor)):not(:hover) {
    text-decoration: none;
  }
`, "",{"version":3,"sources":["webpack://./src/ui/anchor.css"],"names":[],"mappings":"AAAA;;EAEE,iBAAiB;EACjB,gCAAgC;EAChC,iCAAiC;EACjC,0BAA0B;EAC1B,gCAAgC;EAChC,0CAA0C;;EAE1C,2BAA2B;EAC3B,YAAY;EACZ,4CAA4C;EAC5C,mBAAmB;EACnB,eAAe;EACf,cAAc;;EAEd,8EAA8E;EAC9E,oBAAoB;EACpB,kBAAkB;EAClB,oBAAoB;EACpB,oBAAoB;EACpB,aAAa;EACb,YAAY;EACZ,aAAa;EACb,0CAAkC;UAAlC,kCAAkC;EAClC,8BAA8B;EAC9B;;qCAEmC;AAuBrC;;AArBE;IACE,SAAS;EACX;;AAEA;IACE,2BAA2B;EAC7B;;AAEA;IACE,iCAAiC;IACjC,yBAAyB;EAC3B;;AAEA;IACE,kCAAkC;EACpC;;AAEA;IACE,4BAA4B;IAC5B,oBAAoB;EACtB;;AAGF;EACE,UAAU;AACZ;;AAGE;IAEE,+BAA+B;IAC/B,6CAA6C;EAC/C;;AAIA;IAEE,8BAA8B;IAC9B,oCAAoC;IACpC,sCAAsC;IACtC,iCAAiC;IACjC,kCAAkC;EACpC;;AAGF,qFAAqF;;AACrF;;;;;EAKE,iBAAiB;EACjB,uBAAuB;EACvB,wBAAwB;EACxB,cAAc;EACd,sBAAsB;AAKxB;;AAHE;IACE,qBAAqB;EACvB","sourcesContent":["a:where(:any-link:not(.button)),\n.d-anchor {\n  --bg: transparent;\n  --bg-hover: var(--color-gray-02);\n  --bg-active: var(--color-gray-01);\n  --color: var(--link-color);\n  --color-hover: var(--link-color);\n  --color-visited: var(--visited-link-color);\n\n  background-color: var(--bg);\n  border: none;\n  border-radius: var(--default-outline-radius);\n  color: var(--color);\n  cursor: pointer;\n  flex-shrink: 0;\n\n  /* Inherit these properties for button.d-anchor. (<a> does this by default.) */\n  font-family: inherit;\n  font-size: inherit;\n  font-weight: inherit;\n  line-height: inherit;\n  min-height: 0;\n  min-width: 0;\n  outline: none;\n  text-decoration: underline 0.075em;\n  text-underline-offset: 0.175em;\n  transition:\n    background-color var(--default-transition),\n    outline var(--default-transition);\n\n  &::-moz-focus-inner {\n    border: 0;\n  }\n\n  &:visited {\n    color: var(--color-visited);\n  }\n\n  &:hover {\n    background-color: var(--bg-hover);\n    color: var(--color-hover);\n  }\n\n  &:active {\n    background-color: var(--bg-active);\n  }\n\n  &:disabled {\n    color: var(--disabled-color);\n    pointer-events: none;\n  }\n}\n\nbutton.d-anchor {\n  padding: 0;\n}\n\n.is-keynav {\n  & a:where(:any-link:not(.button)):focus,\n  & .d-anchor:focus {\n    outline: var(--default-outline);\n    outline-offset: var(--default-outline-offset);\n  }\n}\n\n.dark-bg {\n  & a:where(:any-link:not(.button)),\n  & .d-anchor {\n    --color: var(--color-white-08);\n    --color-hover: var(--color-white-08);\n    --color-visited: var(--color-white-08);\n    --bg-hover: var(--color-white-03);\n    --bg-active: var(--color-white-01);\n  }\n}\n\n/* Less prominent link variant: no text decoration, and appears blue on hover only. */\n.d-anchor-light,\n  /* This style was used already before this anchor variant was defined. In order not to have to duplicate the style\n  while also not to have have to retrofit all places where it was already used, we provide this special context class.\n  Most new usages should probably assign the \"d-anchor-light\" class on the links themselves, for more flexibility. */\n.d-anchor-light-context :is(a:where(:any-link:not(.button)), .d-anchor) {\n  --bg: transparent;\n  --bg-hover: transparent;\n  --bg-active: transparent;\n  --color: unset;\n  --color-visited: unset;\n\n  &:not(:hover) {\n    text-decoration: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
var ___CSS_LOADER_STYLE_SHEET___ = new CSSStyleSheet();
___CSS_LOADER_STYLE_SHEET___.replaceSync(___CSS_LOADER_EXPORT___.toString());
export default ___CSS_LOADER_STYLE_SHEET___;
